import { render, staticRenderFns } from "./My442.vue?vue&type=template&id=d5dca5c0"
import script from "./My442.vue?vue&type=script&lang=js"
export * from "./My442.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports